import { useContext } from 'react'
import { useTranslation } from 'libs/i18n'
import { NavLink } from 'libs/router'

import { routes } from 'config/routes'
import { AuthContext } from 'store'
import { Avatar } from 'shared/atoms'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type ProfileChipProps = WithClassName

export const ProfileChip = ({ className }: ProfileChipProps) => {
	const { t } = useTranslation()
	const { auth } = useContext(AuthContext)
	const userName: string | undefined = auth?.user?.name || auth?.user?.email

	return (
		<NavLink
			to={routes.profileIndex}
			className={({ isActive }) =>
				cn(
					'flex shrink-0 items-center gap-2 rounded-md border border-border bg-card px-2.5 py-1.5 transition-colors hover:bg-muted',
					isActive && 'bg-muted',
					className
				)
			}>
			<Avatar name={userName} indicator={!auth?.user?.payout_method} className="bg-primary-soft" />
			<div className="max-w-[160px] pr-1 leading-tight">
				<p className="truncate text-[12px] font-semibold">{userName}</p>
				<p className="text-[10px] text-muted-foreground">{t('Profile')}</p>
			</div>
		</NavLink>
	)
}
